import styled from '@emotion/styled';
import { MaskedPartNumberInput } from 'components/form/MaskedPartNumberInput';

export const Form = styled.form`
  position: relative;
`;

export const SearchPartNumberInput = styled(MaskedPartNumberInput)`
  padding: 3px 24px 3px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);

  &:focus {
    outline: 0;
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  }

  &.has-error {
    background-color: ${({ theme }) => theme.colors.backgroundDanger};
    border-color: ${({ theme }) => theme.colors.borderDanger};
    box-shadow: none;
  }
`;
export const ErrorMessage = styled.p`
  position: absolute;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 12px;
  padding: 10px 0;
`;

export const SubmitButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  height: 23px;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0;

  &:hover {
    cursor: pointer;
  }

  > svg {
    width: 16px;
    height: 16px;
  }
`;
